import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { IUserDetails } from '../common/types';
import { getUser } from '../services/apiEndpoints';

export interface IFetchUserPayload {
  idToken: any;
}

export const fetchUserDetails = createAsyncThunk<IUserDetails, IFetchUserPayload, { rejectValue: string }>(
    'user/fetchUserDetails',
    async (payload, thunkAPI) => {
      try {
        const response = await getUser({
          ...payload,
        });

        return response;
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        return thunkAPI.rejectWithValue(errorMessage);
      }
    }
  );

interface IUserState {
    userDetails: IUserDetails | null;
    loading: boolean;
    error: string | null;
}

const initialState: IUserState = {
    userDetails: null,
    loading: true,
    error: null,
  };

  const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
      addUserDetails(state, action){
        state.userDetails = action.payload;
      },
      setAppLoading(state, action){
        state.loading = action.payload;
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchUserDetails.pending, (state) => {
          state.loading = true;
        })
        .addCase(fetchUserDetails.fulfilled, (state, action) => {
          if (action.payload.departments.length > 0) {
            state.userDetails = action.payload;
            const originalUrl = window.location.href.split("?")[0];
            window.history.replaceState({}, document.title, originalUrl);
            state.loading = false;
          }
        })
        .addCase(fetchUserDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string ?? null;
        });
    },
  });
  
  export const { addUserDetails, setAppLoading } = userSlice.actions;
  export default userSlice.reducer;